<div class="form-group">
    <dv-radio-container-x>
        <span>
            <label class="required ebegu-h1" for="quellenbesteuert_id">
                {{ 'QUELLENBESTEUERT' | translate }}
            </label>
        </span>
        <mat-radio-group
            #quellenbesteuert="ngModel"
            (ngModelChange)="onQuellenbesteuertChange()"
            [(ngModel)]="getFinSitJA().quellenbesteuert"
            [enableExpression]="!readonly"
            dvEnableElement
            id="quellenbesteuert_id"
            name="quellenbesteuert"
            required
            data-test="quellenbesteuert"
        >
            <mat-radio-button data-test="radio-value.true" [value]="true">{{
                'LABEL_JA' | translate
            }}</mat-radio-button>
            <mat-radio-button data-test="radio-value.false" [value]="false">{{
                'LABEL_NEIN' | translate
            }}</mat-radio-button>
        </mat-radio-group>
        @if (quellenbesteuert.touched) {
            <dv-error-messages
                [errorObject]="quellenbesteuert.errors"
                inputId="quellenbesteuert_id"
            >
            </dv-error-messages>
        }
    </dv-radio-container-x>
</div>

@if (isNotNullOrUndefined(getFinSitJA().quellenbesteuert)) {
    @if (getFinSitJA().quellenbesteuert) {
        <dv-bruttolohn-schwyz
            (valueChanged)="emitValueChanged()"
            [finSitGS]="
                finanzModel.getFiSiConToWorkWith().finanzielleSituationGS
            "
            [finSitJA]="
                finanzModel.getFiSiConToWorkWith().finanzielleSituationJA
            "
            [readonly]="readonly"
        >
        </dv-bruttolohn-schwyz>
    } @else {
        <dv-steuerveranlagt-schwyz
            (valueChanged)="emitValueChanged()"
            [finSitGS]="
                finanzModel.getFiSiConToWorkWith().finanzielleSituationGS
            "
            [finSitJA]="
                finanzModel.getFiSiConToWorkWith().finanzielleSituationJA
            "
            [readonly]="readonly"
            [schwyzErweiterteFinSit]="schwyzErweiterteFinSit"
        >
        </dv-steuerveranlagt-schwyz>
    }
}
